import styled from "styled-components";

export const ViewModeSwitchContainer = styled.div`
  .view-mode-switch {
    display: flex;
    align-items: center;
    gap: 4px;
    background-color: #d9dde5;
    border: none;
    box-shadow: none;
    outline: none;
    border-radius: 2px;
    padding: 0 8px;
  }

  .view-mode-item {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100% - 4px);
    padding: 0 8px;
    border-radius: 2px;
    font-weight: 600;
    color: #333333;
    white-space: nowrap;
    cursor: pointer;
    min-height: 0;
    line-height: 1;

    &-active {
      background-color: #1e3665;
      color: #ffffff;
    }

    &:hover {
      color: #40a9ff;
    }

    &-disabled {
      color: #a3a6b3;
      cursor: not-allowed;
      font-weight: 400;
    }
  }
`;
